module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.b8e42971.ttf";